import { Box, Breadcrumbs, Link, Tab, Tabs, Typography } from "@mui/material";
import { BackButton } from "../../../../../common/components/back_button";
import {
  PageTopBar,
  ThreeSlotLayout,
} from "../../../../../common/components/page_top_bar";
import PrimaryButton from "../../../../../common/components/primary_button";
import RefreshButton from "../../../../../common/components/refresh_button";
import { Link as LinkTo } from "react-router";
import { useProjetoCadastroViewModel } from "../../viewModels/projetos_cadastro_view_model";
import { TabInformacoesGeraisContent } from "./components/tab_informacoes_gerais_content";
import { AnexarDocumentosContent } from "./components/enexar_documento_componet";
import { InformacoesProjetoContent } from "./components/informacoes_projeto_component";
import { AnexarDocumentosModelContent } from "./components/anexar_documento_model";
import DeleteDialog from "../../../../../common/components/delete_dialog";
import { InformacoesProjetoModelContent } from "./components/informacoesprojeto_model";
import { StyledDataGridTree } from "../../../../../common/components/styled_data_grid_tree";
import { GenerateProjetoDisciplinasColumnDefinition } from "./columns/disciplina";
import { useMemo } from "react";
import { HeaderDisciplina } from "./components/header_disciplinas";
import DynamicIcon from "../../../../../common/components/dynamic_icon";
import { DisciplinaModelContent } from "./components/disciplina_create_model";
import { GetAllDisciplinasArquivosDaoModel } from "../../../domain/models/disciplina_arquivo_models";
import { StyledDataGrid } from "../../../../../common/components/styled_data_grid";
import { GenerateProjetoDisciplinasArquivosColumnDefinition } from "./columns/disciplinaArquivos";
import { DisciplinaArquivoModelContent } from "./components/disciplina_arquivos_model";
import { DisciplinaLista } from "../../../domain/models/disciplina_lista";
import { ProjetoRevisaoModal } from "./components/projeto_revisao_modal";
import { ProjetoRevisaoResumoForm } from "../../schemas/Projetos_cadastro/projeto_revisao";
import { ChangeHistoryModal } from "../../../../../common/modals/change_history_modal";
import BottomBar from "../../../../../common/components/bottom_bar";
import { isValidId } from "../../../../../common/utils/utils";
import { CopiaDisciplinaModal } from "./components/copia_disciplina_modal";
import { ReportViewerModal } from "../../../../../common/components/report_viewer_modal";
import { ReportMenuButton } from "../../../../../common/components/report_button";

export const ProjetosCadastro = () => {
  const viewModel = useProjetoCadastroViewModel();

  const columnsDefinition = useMemo(() => {
    return GenerateProjetoDisciplinasColumnDefinition({
      onActionEditar: viewModel.handleEdicaoDisciplinaOpenState,
      onActionDeletar: viewModel.DeleteOpenModalDisciplina,
      onActionViewItem: viewModel.handleViewChecklist,
      onActionRemoverChecklist: viewModel.handleRemoverChecklistOpenModal,
      onActionCopiar: viewModel.handleCopiaOpenState,
    });
  }, [
    viewModel.DeleteOpenModalDisciplina,
    viewModel.handleCopiaOpenState,
    viewModel.handleEdicaoDisciplinaOpenState,
    viewModel.handleRemoverChecklistOpenModal,
    viewModel.handleViewChecklist,
  ]);

  const columnsDefinitionArquivos = useMemo(() => {
    return GenerateProjetoDisciplinasArquivosColumnDefinition({
      onActionEditar: viewModel.handleEditDisciplinaArquivoOpenState,
      onActionDeletar: viewModel.DeleteOpenModalDisciplinaArquivo,
      onDownloadFile: viewModel.handleDownloadFile,
      onOpenChangeHistory: viewModel.handleOpenChangeHistory,
    });
  }, [
    viewModel.DeleteOpenModalDisciplinaArquivo,
    viewModel.handleDownloadFile,
    viewModel.handleEditDisciplinaArquivoOpenState,
    viewModel.handleOpenChangeHistory,
  ]);

  return (
    <>
      <PageTopBar>
        <ThreeSlotLayout
          leftSlot={
            <div className="flex items-center ml-6">
              <div className="flex items-center bg-white border border-gray-200 rounded-md shadow-sm overflow-hidden h-[34px]">
                <div className="bg-gray-100 text-black text-[10px] font-bold uppercase tracking-wider px-3 h-full flex items-center border-r border-gray-200">
                  Centro de Custo
                </div>
                <div className="px-4 text-sm font-bold text-primary-green h-full flex items-center">
                  {viewModel.nomeCentroCusto || "-"}
                </div>
              </div>
            </div>
          }
          rightSlot={
            <div className="flex flex-row items-center gap-2 mr-6">
              {viewModel.currentTab === 2 && (
                <>
                  <div>
                    <PrimaryButton
                      className="whitespace-nowrap"
                      startIcon={
                        <DynamicIcon
                          nameIcon="Add"
                          size={20}
                          className="text-white"
                        />
                      }
                      onClick={() => viewModel.handleDisciplina(false)}
                    >
                      Nova Disciplina
                    </PrimaryButton>
                  </div>
                  <div>
                    <PrimaryButton
                      buttonColor="secondary-orange"
                      className="whitespace-nowrap"
                      startIcon={
                        <DynamicIcon
                          nameIcon="Add"
                          size={20}
                          className="text-white"
                        />
                      }
                      sx={{
                        px: 2,
                        height: "36px",
                        fontSize: "0.875rem",
                      }}
                      onClick={() => viewModel.handleDisciplina(true)}
                    >
                      Nova Subdisciplina
                    </PrimaryButton>
                  </div>
                </>
              )}

              {viewModel.idProjeto > 0 && (
                <div className="w-[12rem]">
                  <ReportMenuButton
                    options={viewModel.opcoesRelatorio}
                    onSelect={viewModel.handleSelecionarRelatorio}
                  />
                </div>
              )}

              <div>
                <BackButton onClick={viewModel.handleVoltar} />
              </div>
            </div>
          }
        />
      </PageTopBar>
      <form
        className="pb-8"
        onSubmit={viewModel.hookForm.handleSubmit(
          viewModel.handleProjetoSubmit,
        )}
      >
        <div className="flex w-full gap-2 flex-col py-2 px-4 mb-20">
          <Breadcrumbs aria-label="breadcrumb" className="cursor-pointer">
            <Link underline="hover" color="inherit">
              Projetos
            </Link>
            <Link underline="hover" color="inherit" component={"span"}>
              <LinkTo to="/Projetos_lista">Lista de Projetos</LinkTo>
            </Link>
            <Typography className="text-primary-green">
              {" "}
              Cadastro de Projetos{" "}
            </Typography>
          </Breadcrumbs>

          <div>
            <div className="div flex justify-between items-center flex-col md:flex-row gap-6 md:gap-0">
              <div className="flex gap-2 items-center w-full">
                <h1 className="text-3xl font-medium text-black dark:text-white">
                  Cadastro de Projetos
                </h1>
                <RefreshButton onClick={viewModel.handleReload} />
              </div>

              <div className="w-full justify-end flex gap-2"></div>
            </div>
          </div>

          <div className="relative bg-transparent">
            <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
              <Tabs
                variant="scrollable"
                scrollButtons="auto"
                slotProps={{
                  startScrollButtonIcon: {
                    className: "text-black dark:text-white",
                  },
                  endScrollButtonIcon: {
                    className: "text-black dark:text-white",
                  },
                  indicator: {
                    style: {
                      background: "#009C4E",
                    },
                  },
                }}
                value={viewModel.currentTab}
                onChange={viewModel.handleTabChange}
              >
                <Tab
                  sx={{
                    textTransform: "none",
                    "&.Mui-selected": {
                      color: "#009C4E",
                    },
                  }}
                  label="Informações Gerais"
                  value={1}
                />

                <Tab
                  sx={{
                    textTransform: "none",
                    "&.Mui-selected": {
                      color: "#009C4E",
                    },
                  }}
                  disabled={false}
                  label="Controle"
                  value={2}
                />

                <Tab
                  sx={{
                    textTransform: "none",
                    "&.Mui-selected": {
                      color: "#009C4E",
                    },
                  }}
                  disabled={false}
                  label="Arquivos"
                  value={3}
                />
              </Tabs>
            </Box>

            {viewModel.currentTab === 1 && (
              <>
                <TabInformacoesGeraisContent
                  saving={viewModel.saving}
                  onSubmit={viewModel.handleProjetoSubmit}
                  selectedProjeto={viewModel.selectedProjeto}
                  hookForm={viewModel.hookForm}
                />

                <AnexarDocumentosContent
                  handleDocumento={viewModel.handleDocumento}
                  documentos={viewModel.arquivosLista}
                  paginationDocumentos={viewModel.paginationAnexarDocumentos}
                  handleRowsPerTableDocChange={
                    viewModel.handleRowsPerTableDocChange
                  }
                  handleTableDocChange={viewModel.handleTableDocChange}
                  loading={viewModel.loading}
                  onActionEditar={viewModel.handleEdicaoDocOpenState}
                  onActionDeletar={viewModel.DeleteOpenModalDocumentos}
                  onActionDownload={
                    viewModel.handleAnexarDocumentosDownloadLista
                  }
                />

                <InformacoesProjetoContent
                  loading={viewModel.loading}
                  handleInformacoes={viewModel.handleInfo}
                  informacoes={viewModel.informacoesLista}
                  pagination={viewModel.paginationInformacoes}
                  onActionEditar={viewModel.handleEdicaoInfoOpenState}
                  onActionDeletar={viewModel.DeleteOpenModalInfo}
                  onFilterinformacoesChange={viewModel.handleInformacoesChange}
                  onFilterDataChange={viewModel.handleDataChange}
                  onFilterClear={viewModel.handleClear}
                  Filterinformacoes={viewModel.filtersInformacoes.Informacoes}
                  Filterdata={viewModel.filtersInformacoes.Data}
                />
              </>
            )}
            {viewModel.currentTab === 2 && (
              <>
                <HeaderDisciplina
                  por={viewModel.filterDisciplina.por ?? null}
                  prancha={viewModel.filterDisciplina.prancha ?? null}
                  revisao={viewModel.filterDisciplina.revisao ?? null}
                  disciplina={viewModel.filterDisciplina.disciplina ?? null}
                  onPorChange={viewModel.handlePorChange}
                  onPranchaChange={viewModel.handlePranchaChange}
                  onRevisaoChange={viewModel.handleRevisaoChange}
                  onDisciplinaChange={viewModel.handleDisciplinaChange}
                  onClear={viewModel.handleClearDisciplina}
                />

                <StyledDataGridTree
                  tableName="ProjetoDisciplinas"
                  disableColumnMenu={false}
                  showToolbar
                  disableRowSelectionOnClick
                  checkboxSelection={false}
                  rows={viewModel.disciplinasLista}
                  loading={viewModel.loading}
                  rowCount={viewModel.paginationDisciplinasProjeto.totalItems}
                  getRowId={(row: DisciplinaLista) => row.IdDisciplina}
                  getTreeDataPath={(row) => {
                    return row.Path && row.Path.length > 0
                      ? row.Path
                      : [String(row.IdDisciplina)];
                  }}
                  groupingColDef={{
                    headerName: "Disciplina",
                    minWidth: 160,
                    flex: 1,
                    valueFormatter: (value: string) => value.split("+[-]+")[0],
                  }}
                  columns={columnsDefinition}
                />
              </>
            )}
            {viewModel.currentTab === 3 && (
              <>
                <div className="w-full flex flex-col gap-8 bg-light-mode-2 dark:bg-dark-mode-2 p-4 rounded-[4px] border border-border-light-mode dark:border-border-dark-mode mb-4">
                  <HeaderDisciplina
                    por={viewModel.filterDisciplina.por ?? null}
                    prancha={viewModel.filterDisciplina.prancha ?? null}
                    revisao={viewModel.filterDisciplina.revisao ?? null}
                    disciplina={viewModel.filterDisciplina.disciplina ?? null}
                    onPorChange={viewModel.handlePorChange}
                    onPranchaChange={viewModel.handlePranchaChange}
                    onRevisaoChange={viewModel.handleRevisaoChange}
                    onDisciplinaChange={viewModel.handleDisciplinaChange}
                    onClear={viewModel.handleClearDisciplina}
                  />

                  <StyledDataGrid
                    tableName="ProjetoDisciplinasArquivos"
                    disableColumnMenu={false}
                    showToolbar
                    disableRowSelectionOnClick
                    checkboxSelection={false}
                    rows={viewModel.disciplinasListaArquivos}
                    loading={viewModel.loading}
                    rowCount={viewModel.disciplinasListaArquivos.length}
                    getRowId={(row: GetAllDisciplinasArquivosDaoModel) =>
                      row.idDisciplina
                    }
                    columns={columnsDefinitionArquivos}
                  />
                </div>
              </>
            )}
          </div>
        </div>
        {viewModel.currentTab === 1 && (
          <>
            <BottomBar>
              <div className="w-full h-full items-center justify-between flex p-4 gap-4">
                <div>
                  {isValidId(viewModel.idProjeto) && (
                    <PrimaryButton
                      buttonColor="yellow"
                      onClick={() =>
                        viewModel.handleOpenChangeHistory(null, null)
                      }
                    >
                      <span className="text-xs">Historico de alterações</span>
                    </PrimaryButton>
                  )}
                </div>

                <div className="flex flex-row gap-4">
                  <div className="p-2 hover:bg-hover-light-gray cursor-pointer dark:hover:bg-border-dark-gray rounded-[4px] font-semibold">
                    <h1
                      className="text-sm text-black dark:text-white"
                      onClick={() => window.history.back()}
                    >
                      Cancelar
                    </h1>
                  </div>
                  <div className="w-[130px]">
                    {viewModel.saving ? (
                      <PrimaryButton>Salvando...</PrimaryButton>
                    ) : (
                      <PrimaryButton
                        type="submit"
                        startIcon={
                          <DynamicIcon
                            nameIcon="CheckRounded"
                            size={25}
                            className="text-white"
                          />
                        }
                      >
                        Salvar
                      </PrimaryButton>
                    )}
                  </div>
                </div>
              </div>
            </BottomBar>
          </>
        )}
      </form>
      <CopiaDisciplinaModal
        open={viewModel.openCopiaModal}
        selectedDisciplinaCopia={viewModel.selectedtDisciplina || undefined}
        titulo="Copia de disciplina"
        saving={viewModel.saving}
        onSubmit={viewModel.handleSubmitCopiaDisciplina}
        onClose={() => viewModel.handleCopiaOpenState(null, false)}
      />

      <AnexarDocumentosModelContent
        open={viewModel.openModalDocumentos}
        saving={viewModel.saving}
        onClose={() => viewModel.setOpenModalDocumentos(false)}
        onSubmit={viewModel.handleaDocumentoSubmit}
        selectedDocumentos={viewModel.selectedDocumento}
        hookForm={viewModel.hookFormDocumento}
        handleArquivoDeleteOpenState={viewModel.handleArquivoDeleteOpenState}
        handleDownload={viewModel.handleDownload}
        onOpenChangeHistory={(id, tabelaTipo) =>
          viewModel.handleOpenChangeHistory(id, tabelaTipo)
        }
      />

      <InformacoesProjetoModelContent
        open={viewModel.openModalInfor}
        saving={viewModel.saving}
        onClose={() => viewModel.setOpenModalInfor(false)}
        onSubmit={viewModel.handleInforSubmit}
        onOpenChangeHistory={(id, tabelaTipo) =>
          viewModel.handleOpenChangeHistory(id, tabelaTipo)
        }
        hookForm={viewModel.hookFormInformacoes}
        selectedInfo={viewModel.selectedInfo}
      />

      <DisciplinaModelContent
        open={viewModel.openModalDisciplina}
        definirDiciplinaOuSub={viewModel.definirModelSubDisciplina}
        saving={viewModel.saving}
        onClose={() => viewModel.setOpenModaDisciplina(false)}
        onSubmit={viewModel.handleDisciplinaSubmit}
        dropDownChecklist={viewModel.dropDownChecklist ?? []}
        dropDownDisciplina={viewModel.dropDownDisciplina ?? []}
        selectedDisciplina={viewModel.selectedtDisciplina}
        onOpenRevisao={viewModel.handleRevisao}
        paginationRevisao={viewModel.paginationResumo}
        revisaoLista={viewModel.revisaoLista}
        handleRowsPerTableChange={viewModel.handleRowsPerTableRevisaoChange}
        handleTableChange={viewModel.handleTableRevisaoChange}
        onActionEditar={viewModel.handleEdicaoRevisaoOpenState}
        onActionDeletar={viewModel.DeleteOpenModalRevisao}
        onOpenChangeHistory={viewModel.handleOpenChangeHistory}
        disciplinaLista={viewModel.disciplinasLista}
      />

      <DisciplinaArquivoModelContent
        open={viewModel.abrirModalDisciplinaArquivo}
        saving={viewModel.saving}
        onClose={viewModel.handlefecharmodelDicilinaArquivos}
        onSubmit={viewModel.handleDisciplinaArquivoSubmit}
        editmod={false}
        dados={viewModel.dadosEditDisciplinaArquivo}
      />

      <ProjetoRevisaoModal
        open={viewModel.openModalRevisao}
        IdDisciplina={viewModel.IdDisciplina}
        saving={viewModel.saving}
        selectedRevisao={
          (viewModel.selectedRevisao ??
            null) as unknown as ProjetoRevisaoResumoForm | null
        }
        onSubmit={viewModel.handleRevisaoSubmit}
        onClose={() => viewModel.setOpenModalRevisao(false)}
        onOpenChangeHistory={viewModel.handleOpenChangeHistory}
      />

      <ChangeHistoryModal changeHistoryHandler={viewModel.changeHistory} />

      <DeleteDialog
        open={viewModel.openDeleteArquivoModal}
        onClose={() => viewModel.setOpenDeleteArquivoModal(false)}
        title={`Você realmente deseja excluir este item?`}
        onDelete={viewModel.handleConfirmarDeletarArquivo}
      />
      <DeleteDialog
        open={viewModel.openDeleteModalRevisao}
        onClose={() => viewModel.setOpenDeleteModalRevisao(false)}
        title={`Você realmente deseja excluir esta revisão?`}
        onDelete={viewModel.DeletarRevisao}
      />
      <DeleteDialog
        open={viewModel.openDeleteArquivoModal}
        onClose={() => viewModel.setOpenDeleteArquivoModal(false)}
        title={`Você realmente deseja excluir este item?`}
        onDelete={viewModel.handleConfirmarDeletarArquivo}
      />
      <DeleteDialog
        open={viewModel.openDeleteModalDoc}
        onClose={() => viewModel.DeleteOpenModalDocumentos(null, false)}
        title={`Você realmente deseja excluir este item?`}
        onDelete={viewModel.DeletarAnexarDocumentos}
      />

      <DeleteDialog
        open={viewModel.openDeleteModalInfor}
        onClose={() => viewModel.DeleteOpenModalInfo(null, false)}
        title={`Você realmente deseja excluir este item?`}
        onDelete={viewModel.DeletarInfor}
      />

      <DeleteDialog
        open={viewModel.openDeleteModalDisciplina}
        onClose={() => viewModel.DeleteOpenModalDisciplina(null, false)}
        title={`Você realmente deseja excluir este item?`}
        onDelete={viewModel.DeletarDisciplina}
      />

      <DeleteDialog
        open={viewModel.openDeleteModalDisciplinaArquivo}
        onClose={() => viewModel.DeleteOpenModalDisciplinaArquivo(null, false)}
        title={`Você realmente deseja excluir estes Arquivos?`}
        onDelete={viewModel.DeletarDisciplinaArquivo}
      />

      <DeleteDialog
        open={viewModel.openRemoveModalDisciplinaCheck}
        onClose={() => viewModel.handleRemoverChecklistOpenModal(null, false)}
        title={`Você realmente deseja excluir estes ?`}
        onDelete={viewModel.handleRemoverChecklist}
      />

      <ChangeHistoryModal changeHistoryHandler={viewModel.changeHistory} />
      <ReportViewerModal reportViewerState={viewModel.reportViewerState} />
    </>
  );
};
